<template>
    <div class="body-width divcss5">
      <div>
        <div class="div-row div-bottom news-Medium-24">
            辽宁省科技厅党组成员、副厅长杜波一行来海事大学调研并对大连海大智龙科技有限公司参观指导
          <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
        </div>
          <div class="div-text-left news-Regular-14b6">
              <span>2022-07-13</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
             </div>
        <div class="div-line  divcss5">
        
        </div>
        <div class="div-row div-bottom10  div-top30">
          <div class="  div-top box2">
            <div class="div-margin " >
              <img src="../../../assets/images/news26/1.jpg" />
            </div>
          </div>
        </div>
        <div class="div-row div-bottom30">
            <p class="indentation">
                7月12日，辽宁省科技厅党组成员、副厅长杜波一行来我校调研，大连市科技局副局长赵宏志、校长孙玉清、副校长初北平等参加调研并进行座谈交流。
              </p>
              <p class="indentation">
                座谈会上，初北平代表学校对杜波一行到来表示热烈欢迎，对辽宁省科技厅长期以来给予学校科技工作的指导和帮助表示感谢。他表示，学校一直致力于科技创新服务辽宁海洋经济和产业发展并取得了一系列成果，希望省科技厅对学校科技创新、人才培养等方面给予进一步关注和支持，学校也将继续加强与省科技厅的沟通与交流，为辽宁省科技发展，做出应有的贡献。</p>
              <p class="indentation">
                杜波表示，通过此次调研，了解到大连海事大学对科研工作的高度重视和科技方面取得的可喜成绩，希望双方建立常态化沟通联络机制，在应用基础研究、产业转化、人才培养和科技人才推广等方面多交流、多发掘、多推荐，集聚科研力量，做好“卡脖子”技术攻关，响应市场需求，尽快推动技术产业化推广，共同在科技创新方面获得新的突破。
              </p>
        </div>
        <div class="div-row div-bottom10">
          <div class="  div-top box2">
            <div class="div-margin " >
              <img src="../../../assets/images/news26/2.jpg" />
            </div>
          </div>
        </div>
  
        <div class="div-row div-bottom10">
          <div class=" div-top box2">
            <div class="div-margin " >
              <img src="../../../assets/images/news26/3.jpg" />
            </div>
          </div>
        </div>

        <div class="div-row div-bottom10">
            <div class=" div-top box2">
              <div class="div-margin " >
                <img src="../../../assets/images/news26/4.jpg" />
              </div>
            </div>
          </div>

          <div class="div-row div-bottom10">
            <div class=" div-top box2">
              <div class="div-margin " >
                <img src="../../../assets/images/news26/5.jpg" />
              </div>
            </div>
          </div>

          <div class="div-row div-bottom10">
            <div class=" div-top box2">
              <div class="div-margin " >
                <img src="../../../assets/images/news26/6.jpg" />
              </div>
            </div>
          </div>

          <div class="div-row div-bottom10">
            <div class=" div-top box2">
              <div class="div-margin " >
                <img src="../../../assets/images/news26/7.jpg" />
              </div>
            </div>
          </div>

        <div class="div-row div-top30 ">
          <p class="indentation div-top0">
            调研期间，杜波一行专程考察了学校船舶导航系统国家工程研究中心、海底工程技术与装备国际联合研究中心、辽宁省水下机器人工程研究中心、大连海大智龙科技有限公司、大连东北亚国际航运中心研究院和救助与打捞工程辽宁省重点实验室。
        </p>
        <p class="indentation div-top0">
            辽宁省科技厅、大连市科技局和学校科技处相关同志陪同调研交流。
        </p>
        <p class="indentation div-top0">
          <a href="https://news.dlmu.edu.cn/info/1021/26631.htm" target="_blank">以上内容来源：辽宁省科技厅党组成员、副厅长杜波一行来我校调研-大连海事大学新闻网 (dlmu.edu.cn)</a>
      </p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    export default {
      data() {
        return {
          isflag1: true,
          isflag2: false,
          isflag3: false
        };
      },
      mounted() {
        window.addEventListener('scroll', this.handleScroll)
      },
      methods: {
        handleScroll() {
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
          if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
            // alert(scrollTop)
            this.isflag2 = true;
          }
          if (parseInt(scrollTop) >= 1200) {
            this.isflag3 = true;
          }
  
        },
        destroyed() {
          window.removeEventListener('scroll', this.handleScroll)
        },
      },
    };
  
  </script>
  
  <style scoped>
    .fl {
      float: right;
      margin-right: 20px;
    }
  
    .fy {
      text-align: center;
      margin-top: 30px;
    }
  
    .title {
      height: 100%;
    }
  
    .div-width {
      width: 75%;
    }
  
  
  
    .div-line {
      background: #E6E6E6;
      height: 1px;
      width: 100%;
  
    }
  
    .div-bottom10 {
      padding-top: 10px;
    }
  
    .div-bottom30 {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  
    .div-top30 {
      padding-top: 30px;
    }
    img {
      vertical-align: middle;
      border-style: none;
      width: 95%; 
      border-radius: 10px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/contentcoms/news2022/news26.vue